import type { Climb } from '../types/climb';
import type { SendClimb } from '../types/send';

/** The path segment a place's pages live under. */
function placeSegment(locationType: string): string {
  return locationType === 'Gym' ? 'gyms' : locationType === 'Crag' ? 'crags' : 'competitions';
}

export function climbUrl(climb: Climb): string {
  const type = climb.type === 'Boulder' ? 'boulders' : 'routes';
  return `/${placeSegment(climb.location.type)}/${climb.location.slug}/${type}/${climb.slug}`;
}

/**
 * The page of the climb a send is of, or null where it has none: a board
 * problem lives under its gym's board, and a global one — no gym, no board —
 * has no page to go to.
 */
export function sendClimbUrl(climb: SendClimb): string | null {
  const { location, slug } = climb;
  if (!location || !slug) return null;

  if (climb.climb_type === 'BoardClimb') {
    return climb.board?.id ? `/gyms/${location.slug}/boards/${climb.board.id}/climbs/${slug}` : null;
  }

  const type = climb.climb_type === 'Route' ? 'routes' : 'boulders';
  return `/${placeSegment(location.type ?? 'Gym')}/${location.slug}/${type}/${slug}`;
}
